"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PetNo = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PetNo = function PetNo(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PetNo_svg__PetNo_svg__clip0_17471_91734)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.456 1.349a1.23 1.23 0 00-.667-.337c-.933-.132-1.929.87-2.215 2.253a3.528 3.528 0 00-.071 1.037l2.953-2.953zM.357 14.805l1 1 1.355-1.355c.152.146.323.268.508.356.834.411 1.777.09 2.737-.237.653-.222 1.314-.447 1.955-.447.646 0 1.31.219 1.965.436.954.315 1.891.625 2.736.248.685-.303 1.259-1.112 1.227-1.842-.04-.912-.816-1.583-1.577-2.241-.296-.256-.59-.51-.837-.774-.307-.322-.595-.716-.886-1.116-.315-.43-.633-.868-.985-1.226l6.261-6.262-1-1L.357 14.805zM5.092 1.012c.94-.132 1.936.87 2.223 2.253.287 1.376-.231 2.604-1.171 2.744-.933.14-1.936-.863-2.231-2.246-.295-1.376.239-2.604 1.179-2.751zM.83 4.586c.908-.38 2.143.311 2.788 1.516C4.223 7.33 4.016 8.62 3.116 9c-.9.381-2.127-.303-2.757-1.523-.63-1.22-.406-2.518.47-2.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.17 4.586c.877.373 1.1 1.671.47 2.891-.629 1.22-1.856 1.904-2.756 1.523-.9-.38-1.107-1.67-.502-2.898.645-1.205 1.88-1.896 2.789-1.516z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PetNo_svg__PetNo_svg__clip0_17471_91734"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};

exports.PetNo = PetNo;
var _default = PetNo;
exports.default = _default;